import { Button, Image } from "@/components/Elements";
import { FriendSuggestionModel, FriendTab } from "../../types";
import { useAcceptRejectFriendRequestMutation } from "@/services/modules/chat";
import { useNavigate } from "react-router-dom";
import { RouteConstant } from "@/routes/routeConstant";

const FriendRequest = ({ recipient }: { recipient: FriendSuggestionModel }) => {
  const { fullName, userImageUrl, userId, isRequestRejected } = recipient;
  const [acceptRejectFriendRequest] = useAcceptRejectFriendRequestMutation();
  const navigate = useNavigate();

  const handleAccept = async () => {
    await acceptRejectFriendRequest({
      userId,
      isAccepted: true,
      isRejected: false,
    });
    navigate(`${RouteConstant.Friends}/${FriendTab.Friends}`);
  };

  const handleReject = () => {
    acceptRejectFriendRequest({ userId, isRejected: true, isAccepted: false });
  };

  return (
    <div className="mb-[15px] min-h-[80px] border-b-[#d3d3d3]">
      <div className="flex">
        <Image
          src={userImageUrl}
          isApiUrl
          className="w-[80px] h-[80px] rounded-[50px] border border-[#d3d3d3]"
        />
        <div className="flex-1 ml-[7px]">
          <div className="flex justify-between">
            <div className="text-[16px] font-extrabold">{fullName}</div>
          </div>
          <div className="flex">
            {isRequestRejected ? (
              <Button disabled variant="secondary">
                Rejected
              </Button>
            ) : (
              <>
                <Button onClick={handleReject} variant="danger">
                  Reject
                </Button>
                <Button onClick={handleAccept} className="ml-[10px]">
                  Accept
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FriendRequest;
